import { useRef } from "react";
import CustomSelectDropdown from "../../../../CustomHTMLElements/CustomSelectDropdown";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import useBusinessTypes from "../../hooks/useBusinessTypes";
import styles from "./BusinessType.module.scss";
import HeaderTitle from "../../Components/HeaderTitle";

const schema = yup.object().shape({
  business_type: yup
    .string()
    .required("Please select business type")
    .notOneOf([""], "Please select business type"),
});

type FormData = {
  business_type: string;
};

interface BusinessTypeProps {
  onContinue: (businessType: string) => void;
  defaultValue?: string;
}

const BusinessType: React.FC<BusinessTypeProps> = ({
  onContinue,
  defaultValue = "",
}) => {
  const formRef = useRef<HTMLFormElement>(null);

  const { register, handleSubmit, errors, watch } = useForm<FormData>({
    resolver: yupResolver(schema),
    defaultValues: {
      business_type: defaultValue,
    },
  });

  const { data: businessTypes, isLoading } = useBusinessTypes();

  const business_type = watch("business_type");

  const onSubmit = (formData: FormData) => {
    onContinue(formData.business_type);
  };

  const handleProceedClick = () => {
    if (formRef.current) {
      formRef.current.requestSubmit();
    }
  };

  return (
    <div className={styles.businessTypeContainer}>
      <div className={styles.content}>
        <HeaderTitle>Choose a Business Type</HeaderTitle>

        <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
          <div className="row mt-4">
            <div className="col-12">
              <CustomSelectDropdown
                label="Business Type"
                name="business_type"
                reference={register}
                errors={errors?.business_type}
                defaultValue={defaultValue}
                isShowLabel={true}
              >
                <option value="">Select business type</option>
                {isLoading && (
                  <option disabled>Loading business types...</option>
                )}
                {businessTypes &&
                  businessTypes?.data?.map((_businessType: any) => (
                    <option key={_businessType?.id} value={_businessType?.id}>
                      {_businessType?.name}
                    </option>
                  ))}
              </CustomSelectDropdown>
            </div>
          </div>

          <div className={styles.actions}>
            <button
              type="button"
              onClick={handleProceedClick}
              className="btn advancly-btn btn-lg btn-block"
              //   disabled={!business_type}
            >
              Proceed
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BusinessType;
